import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Constants from "../../constants";

const initialState = {
    loading: false,
    showloader:false,
}

export const adminUserAccountJsonFunction = createAsyncThunk(
    'admin/userAccountPicklistJSON',async(credentials) => {
        try{
            const response = await fetch(Constants.Api.commonUrl+'TableColumnLookupJSON?Token='+credentials.token+'&TableName='+credentials.Tablename+'&ColumnName='+credentials.ColumnName+'&Language='+(credentials.language === undefined ? 'en-gb' : credentials.language),{
                method : 'get' 
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return console.log('AccountJSON',err)
        }
    }
)




export const AddcolumnJSONFunction = createAsyncThunk(
    'admin/userAccountPicklistJSON',async(credentials) => {
        console.log("credentials",credentials)
        try{
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateColumnJSON?Token='+credentials.token+'&Table='+credentials.formData.tableName+'&Column='+credentials.formData.columnname+'&Keys='+credentials.formData.keys+'&DataType='+credentials.formData.dataType+'&Length='+credentials.formData.length+'&Description='+credentials.formData.description+'&Label='+credentials.formData.lableName+'&Mandatory='+credentials.formData.mandatory+'&XrefTable='+credentials.formData.XrefTable+'&XrefType='+credentials.formData.XrefType+'&XrefCode='+credentials.formData.XrefCode+'&XrefValue='+credentials.formData.XrefValue+'&AllowedCode='+credentials.formData.AllowedCode+'&AllowedValues='+credentials.formData.AllowedValues,{
                method : 'get' 
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return console.log('AccountJSON',err)
        }
    }
)


export const AddLookupsJSONFunction = createAsyncThunk(
    'admin/userAccountPicklistJSON',async(credentials) => {
        console.log("credentials",credentials)
        try{
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateLookupJSON?Token='+credentials.token+'&Language='+credentials.formData.Language+'&Category='+credentials.formData.Category+'&Code='+credentials.formData.Code+'&ExternalCode='+credentials.formData.ExternalCode+'&Active='+credentials.formData.Active+'&Value='+credentials.formData.Value+'&Pronoun='+credentials.formData.Pronoun,{
                method : 'get' 
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return console.log('AccountJSON',err)
        }
    }
)


export const AddlanguageJSONFunction = createAsyncThunk(
    'admin/userAccountPicklistJSON',async(credentials) => {
        console.log("credentials",credentials)
        try{
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateLanguageJSON?Token='+credentials.token+'&Language='+credentials.formData.Language+'&Code='+credentials.formData.Code+'&TextString='+credentials.formData.TextString+'&Pronoun='+credentials.formData.pronoun,{
                method : 'get' 
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return console.log('AccountJSON',err)
        }
    }
)

export const UserAccountsDetailsJSON = createAsyncThunk(
    'admin/UserAccountJSON',async(credentials) => {
        try{
            const response = await fetch(Constants.Api.commonUrl+'UserAccountJSON?Token='+credentials.token+'&UserName='+credentials.userName,{
                method : 'get' 
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return console.log('AccountJSON',err)
        }
    }
)

export const AddUserAccountsDetailsJSON = createAsyncThunk(
    'admin/AddUpdateUserProfileJSON',async(credentials) => {
        try{
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateUserProfileJSON?Token='+credentials.token+'&Country='+credentials.formData.CountryCode+'&UserName='+credentials.formData.UserName+'&Name='+credentials.formData.Name+'&SecurityGroup='+credentials.formData.SecurityGroup+'&SecurityLevel='+credentials.formData.SecurityLevel+'&Password='+credentials.formData.password+'&EmailAddress='+credentials.formData.EmailAddress+'&AccountExpiry='+credentials.formData.AccountExpiry+'&Disabled='+credentials.formData.Disabled+'&Lanaguage='+credentials.formData.Language+'&Question='+credentials.formData.SecurityQuestion+'&Answer='+credentials.formData.SecurityAnswer+'&Mobile='+credentials.formData.Mobile+'&Pronoun='+credentials.formData.Pronoun+'&LastScreen='+credentials.formData.LastScreen,{
                method : 'get' 
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return console.log('AccountJSON',err)
        }
    }
)

export const UpdateUserAccountsDetailsJSON = createAsyncThunk(
    'admin/UpdateUserAccountsDetailsJSON',async(credentials) => {
        try{
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateUserProfileJSON?Token='+credentials.token+'&Country='+credentials.formData.Country+'&UserName='+credentials.formData.UserName+'&Name='+credentials.formData.Name+'&SecurityGroup='+credentials.formData.SecurityGroup+'&SecurityLevel='+credentials.formData.SecurityLevel+'&Password='+credentials.formData.password+'&EmailAddress='+credentials.formData.EmailAddress+'&AccountExpiry='+credentials.formData.AccountExpiry+'&Disabled='+credentials.formData.Disabled+'&Lanaguage='+credentials.formData.Language+'&Question='+credentials.formData.SecurityQuestion+'&Answer='+credentials.formData.SecurityAnswer+'&Mobile='+credentials.formData.Mobile+'&Pronoun='+credentials.formData.Pronoun+'&LastScreen='+credentials.formData.LastScreen,{
                method : 'get' 
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return console.log('AccountJSON',err)
        }
    }
)


export const UpdateResourceDocumentDetailsJSON = createAsyncThunk(
    'admin/UpdateResourceDocumentDetailsJSON', async(credentials) => {
        try{
            const response = await fetch(Constants.Api.commonUrl+'UpdateResourceJSON?Token='+credentials.token+'&CID='+credentials.cId+'&DocumentID='+credentials.formData.documentID+'&DocumentType='+credentials.formData.documentType+'&Name='+credentials.formData.Name,'&Active='+credentials.formData.Active+'&Filename='+credentials.formData.fileName+'&Description='+credentials.formData.description+'&Sort='+credentials.formData.Order,'&Category='+credentials.formData.CategoriesOne+'&Category2='+credentials.formData.CategoriesTwo+'&Category3='+credentials.formData.CategoriesThree,{
                method : 'get' 
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return console.log("company json err",err)
        }
    }
)


export const addeResourceDocumentDetailsJSON = createAsyncThunk(
    'admin/addeResourceDocumentDetailsJSON', async(credentials) => {
        try{
            const response = await fetch(Constants.Api.commonUrl+'AddResourceJSON?Token='+credentials.token+'&CID='+credentials.cId+'&Name='+credentials.formData.Name,'&Active='+credentials.formData.Active+'&Filename='+credentials.formData.fileName+'&Description='+credentials.formData.description+'&Sort='+credentials.formData.Order,'&Category='+credentials.formData.CategoriesOne+'&Category2='+credentials.formData.CategoriesTwo+'&Category3='+credentials.formData.CategoriesThree,{
                method : 'get' 
            })
            const data = await response.json()
            return data
        }
        catch(err){
            return console.log("company json err",err)
        }
    }
)

export const adminuserAccountSlice = createSlice({
    name : 'admin/adminuserAccountSlice',
    initialState,
    reducers : {},
    extraReducers : {
        [UserAccountsDetailsJSON.pending] : (state, action) => {
            state.showloader=true;
        },
        [UserAccountsDetailsJSON.fulfilled] : (state, action) => {
            state.showloader=false;
        },
        [UserAccountsDetailsJSON.rejected] : (state, action) => {
            state.showloader=false;
        },
        [AddUserAccountsDetailsJSON.pending] : (state, action) => {
           
        },
        [AddUserAccountsDetailsJSON.fulfilled] : (state, action) => {
          
        },
        [AddUserAccountsDetailsJSON.rejected] : (state, action) => {
       
            
        },
        [AddcolumnJSONFunction.pending] : (state, action) => {
           
        },
        [AddcolumnJSONFunction.fulfilled] : (state, action) => {
          
        },
        [AddcolumnJSONFunction.rejected] : (state, action) => {
       
            
        },
        [AddLookupsJSONFunction.pending] : (state, action) => {
           
        },
        [AddLookupsJSONFunction.fulfilled] : (state, action) => {
          
        },
        [AddLookupsJSONFunction.rejected] : (state, action) => {
       
            
        },
        
        [UpdateUserAccountsDetailsJSON.pending] : (state, action) => {
          

        },
        [UpdateUserAccountsDetailsJSON.fulfilled] : (state, action) => {
           
        },
        [UpdateUserAccountsDetailsJSON.rejected] : (state, action) => {
           
            
        },
        [UpdateResourceDocumentDetailsJSON.pending] : (state, action) => {
            state.loading = true;

        },
        [UpdateResourceDocumentDetailsJSON.fulfilled] : (state, action) => {
            state.clientList = action['payload']['Result']['Client'];
            state.loading = true;
        },
        [UpdateResourceDocumentDetailsJSON.rejected] : (state, action) => {
            state.loading = false;
            
        },
        [addeResourceDocumentDetailsJSON.pending] : (state, action) => {
            state.loading = true;

        },
        [addeResourceDocumentDetailsJSON.fulfilled] : (state, action) => {
            state.clientList = action['payload']['Result']['Client'];
            state.loading = false;
        },
        [addeResourceDocumentDetailsJSON.rejected] : (state, action) => {
            state.loading = false;
        },
        
    }
})

export const {} = adminuserAccountSlice.actions
export default adminuserAccountSlice.reducer
